/**
 * 企业端 — 车辆备案（列表 + 新增）
 * 业务规则：每车核载 43-45 头
 */
import { useEffect, useState } from 'react';
import { createVehicle, fetchVehicles } from '@/api/transit';
import { Empty, Loading, PageHeader, StatusTag } from '@/components/common';
import type { TransitVehicle } from '@/types';

/** 牛只核载范围（业务规则：每车 43-45 头） */
const CATTLE_CAPACITY_MIN = 43;
const CATTLE_CAPACITY_MAX = 45;
const CATTLE_CAPACITY_DEFAULT = 44;

export default function EntVehicles() {
  const [vehicles, setVehicles] = useState<TransitVehicle[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ plate_no: '', vehicle_type: '厢式', cattle_capacity: CATTLE_CAPACITY_DEFAULT, transport_license_no: '', gps_authorized: 1 });

  const load = () => {
    fetchVehicles().then((d) => {
      setVehicles(d.list);
      setLoading(false);
    });
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) return <Loading />;

  const submit = async () => {
    if (!form.plate_no) {
      alert('请填写车牌号');
      return;
    }
    if (form.cattle_capacity < CATTLE_CAPACITY_MIN || form.cattle_capacity > CATTLE_CAPACITY_MAX) {
      alert(`牛只核载应为每车 ${CATTLE_CAPACITY_MIN}-${CATTLE_CAPACITY_MAX} 头`);
      return;
    }
    await createVehicle({ ...form, owner_id: 3001 });
    setShowForm(false);
    load();
  };

  return (
    <div>
      <PageHeader
        title="车辆备案"
        sub="运输车辆管理（道路运输证 / GPS 授权）"
        extra={
          <button className="btn btn-primary" onClick={() => setShowForm((v) => !v)}>
            {showForm ? '收起表单' : '＋ 备案车辆'}
          </button>
        }
      />

      {showForm && (
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-title">新增车辆</div>
          <div className="grid grid-3">
            <div className="field">
              <label>车牌号 *</label>
              <input value={form.plate_no} onChange={(e) => setForm((f) => ({ ...f, plate_no: e.target.value }))} placeholder="鲁A12345" />
            </div>
            <div className="field">
              <label>车辆类型</label>
              <select value={form.vehicle_type} onChange={(e) => setForm((f) => ({ ...f, vehicle_type: e.target.value }))}>
                <option>厢式</option>
                <option>高栏</option>
                <option>冷藏</option>
              </select>
            </div>
            <div className="field">
              <label>牛只核载（头）</label>
              <input type="number" min={CATTLE_CAPACITY_MIN} max={CATTLE_CAPACITY_MAX} placeholder={`每车 ${CATTLE_CAPACITY_MIN}-${CATTLE_CAPACITY_MAX} 头`} value={form.cattle_capacity} onChange={(e) => setForm((f) => ({ ...f, cattle_capacity: Number(e.target.value) }))} />
            </div>
          </div>
          <div className="grid grid-2">
            <div className="field">
              <label>道路运输证号</label>
              <input value={form.transport_license_no} onChange={(e) => setForm((f) => ({ ...f, transport_license_no: e.target.value }))} />
            </div>
            <div className="field">
              <label>GPS 采集授权</label>
              <select value={form.gps_authorized} onChange={(e) => setForm((f) => ({ ...f, gps_authorized: Number(e.target.value) }))}>
                <option value={1}>已授权</option>
                <option value={0}>未授权</option>
              </select>
            </div>
          </div>
          <button className="btn btn-primary" onClick={submit}>
            保存
          </button>
        </div>
      )}

      <div className="card">
        {vehicles.length === 0 ? (
          <Empty />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>车牌</th>
                <th>类型</th>
                <th>核载</th>
                <th>运输证号</th>
                <th>GPS 授权</th>
                <th>状态</th>
              </tr>
            </thead>
            <tbody>
              {vehicles.map((v) => (
                <tr key={v.id}>
                  <td>
                    <strong>{v.plate_no}</strong>
                  </td>
                  <td>{v.vehicle_type}</td>
                  <td>{v.cattle_capacity} 头 / {v.capacity_kg}kg</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{v.transport_license_no || '—'}</td>
                  <td>{v.gps_authorized === 1 ? '✅ 已授权' : '❌ 未授权'}</td>
                  <td>
                    <StatusTag tone={v.status === 0 ? 'green' : 'muted'}>{v.status === 0 ? '正常' : '停用'}</StatusTag>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
